import {
    isFunction,
    isString,
    aboutBrow,
    deepMixin,
    deepClone,
    parallel,
    isObject,
    isNaN,
    urlArgs2object,
    ajax
} from "../../funcs";
import Events from "../Events";
import _ from "underscore";
import $ from "jquery";
import Backbone from "backbone";
import AppManager from "../../apps/AppManager";
import User from "./User";
import socketClient from "./socketClient";
import Api from "../api/Api";
import RowsStorage from "../storage/RowsStorage";
import langDictionary from "../lang/init";
import RightsManager from "../system/rights/RightsManager";
import runs from "../../apps/runs";
import allGridsConfig from "../../classes/grid/config";
import "../../plugins/jquery.cookie";
import { liveReload } from "../lang/liveReload";
import { AdminQueriesTools } from "./AdminQueriesTools";

RowsStorage.EXCLUDE_FROM_RIGHTS_FILTER = RightsManager.BaseRights.EXCLUDE_FROM_RIGHTS_FILTER;

window.RowsStorage = RowsStorage;
window.Api = Api;
window.langDictionary = langDictionary;

const OFFICE_ONLINE_URL = "https://view.officeapps.live.com/op/view.aspx?src=";
const SYS_CLIENT_OPTIONS = RowsStorage.get("SYS_CLIENT_OPTIONS");
const SETTINGS = RowsStorage.get("SETTINGS");
const isMobile = aboutBrow().isMobile;

export default class System extends Events {
    constructor(params) {
        super();
        this.init(params);
    }

    async init(params) {
        params = deepMixin({
            onReady() {}
        }, params);
        window.system = this;

        this.runs = runs;

        // timezone for server
        $.cookie("timezone", new Date().getTimezoneOffset());

        // fix browsers bugs with makeup
        $("html")
            .addClass(aboutBrow().brow)
            .attr("pxl-ratio", window.devicePixelRatio || 1);

        if ( isMobile ) {
            $("body").addClass("mobile");
        }

        this.actionByExt = {
            xls: "office",
            xlsx: "office",
            doc: "office",
            docx: "office",
            jpg: "iframe",
            jpeg: "iframe",
            png: "iframe",
            pdf: "iframe"
        };

        this.appsToRunFromNewModules = [];

        this._requiredNewModules = {};

        this.initErrors();

        this.user = new User();

        this.initSocketClient();

        this.listenTo(this.user, "*", (eventName) => {
            let args = [].slice.call(arguments);
            args[0] = "user:" + eventName;
            this.trigger.apply(this, args);
        });

        await Promise.all([
            this.user.load(),
            SYS_CLIENT_OPTIONS.get({ limit: "all" }),
            SETTINGS.get({ limit: "all" })
        ]);

        this.initOptions(
            SYS_CLIENT_OPTIONS.collection.models,
            SETTINGS.collection.first()
        );

        await this.initTheme();

        const result = await this.loadProjectConfig();
        const {modules, project} = result;

        await this.initModules(modules, project);

        this.initRightsManager();

        // MainMenu можно запустить только после прав
        this.rights.once("ready", () => {
            this.initAppManager();
        });

        // system ready when:
        parallel([
            (next) => {
                this.once("apps:ready", next.bind(this, null));
            },
            (next) => {
                this.once("rights:ready", next.bind(this, null));
            }
        ], () => {

            // dev stuff
            if ( this.isStaging() || this.isLocalhost() || this.user.isAdmin() ) {
                this.apps.run("Dev");
            }

            if ( this.user.isAdmin() || this.isLocalhost() ) {
                this.adminQueries = new AdminQueriesTools();
            }

            if ( window.location.hash ) {
                this.runLink(window.location.hash);
            }

            params.onReady();
        });
    }

    isStaging() {
        return /\.staging\./.test(location.href);
    }

    isLocalhost() {
        return /localhost|127\.0\.0\.1/.test(location.href);
    }

    initErrors() {
        let consoleErorr = console.error;
        let that = this;

        console.error = function(data) {
            // that - system
            // this - console

            let description = {
                data,
                stack: new Error().stack
            };
            that.remoteLog("console.error", "", description);
            return consoleErorr.apply(this, arguments);
        };

        window.onerror = function(msg, url, line, column, error) {
            error = error || new Error("do not support");
            that.remoteLog("window.error", msg, error.stack);
        };
    }

    // подключаем кастомные словари клиентов,
    // это нужно сделать ДО самого первого запроса через RowsStorage,
    // иначе нужно будет применять изменения в RowsStorage
    async loadProjectConfig() {
        let modules = window.clientModules || [];
        let project = window.project;

        // чтобы можно было потестить разные вариации системы
        // на dev-perm
        if ( localStorage.getItem("modules") ) { // старое понятие модулей
            try {
                modules = JSON.parse(localStorage.getItem("modules"));
            } catch (err) {
                console.error(err);
            }
        }

        if ( !modules.length ) {
            return { modules, project };
        }

        // на практике можно встретить только один модуль (старый модуль)
        const [
            someFieldNames,
            someForms,
            ruFieldNames,
            ruForms
        ] = await asyncRequire([
            "weak-json!modules/" + modules[0] + "/lang/" + window.lang + "/field_name",
            "weak-json!modules/" + modules[0] + "/lang/" + window.lang + "/forms",
            "weak-json!modules/" + modules[0] + "/lang/ru/field_name",
            "weak-json!modules/" + modules[0] + "/lang/ru/forms"
        ]);

        langDictionary.FIELD_NAME = this._mergeDictionary(
            langDictionary.FIELD_NAME,
            ruFieldNames,
            someFieldNames
        );

        langDictionary.FORMS = this._mergeDictionary(
            langDictionary.FORMS,
            ruForms,
            someForms
        );

        return { modules, project };
    }

    _mergeDictionary(original, ruCustom, custom) {
        if ( !isObject(ruCustom) ) {
            return original;
        }

        for (let tableName in ruCustom) {
            let ruCustomFields = ruCustom[ tableName ];
            if ( !isObject(ruCustomFields) ) {
                continue;
            }

            let originalFields = original[ tableName ] || {};
            for (let key in ruCustomFields) {
                let customTranslate = ruCustomFields[ key ];

                originalFields[ key ] = customTranslate;
            }

            original[ tableName ] = originalFields;
        }

        for (let tableName in custom) {
            let customFields = custom[ tableName ];
            if ( !isObject(customFields) ) {
                continue;
            }

            let originalFields = original[ tableName ] || {};
            for (let key in customFields) {
                let customTranslate = customFields[ key ];

                originalFields[ key ] = customTranslate;
                originalFields[ key + "__old_module" ] = true;
            }

            original[ tableName ] = originalFields;
        }

        return original;
    }

    async initTheme() {
        let style = document.createElement("style");
        style.id = "theme";
        document.body.appendChild(style);

        let themeTemplate;
        let renderTheme = () => {
            let css = _.template(themeTemplate)(this.theme.attributes);
            style.innerHTML = css;
        };

        let theme = this.options.get("theme");
        if ( !theme ) {
            theme = "main";
        }

        const requiredFiles = await asyncRequire([
            "classes/themes/template.css",
            "classes/themes/" + theme + "/theme.json",
            // файла может и не быть
            "css!classes/themes/" + theme + "/theme"
        ]);
        const [template, scope] = requiredFiles;

        themeTemplate = template;
        this.theme = new Backbone.Model(scope);
        renderTheme();
        this.theme.on("change", renderTheme);
        this.trigger("theme:ready");
    }

    initSocketClient() {
        this.socketClient = socketClient;
        // кастомный инит нашего приложения,
        // серверу нужно знать с кем он имеет дело
        socketClient.emit("appInit", {
            deviceType: aboutBrow().isMobile ? "mobile" : "desktop",
            userId: this.user.id,
            // deviceId defined in main-login
            deviceId: $.cookie("deviceId")
        });

        this.user.subscribeOnSocket(socketClient);

        RowsStorage.onReadySocket(socketClient);
        liveReload(langDictionary, socketClient);

        this.trigger("ready:socket");
    }

    onReadySocket(handler) {
        if ( this.socketClient ) {
            handler(this.socketClient);
        }
        else {
            this.once("ready:socket", () => {
                handler(this.socketClient);
            });
        }
    }

    initOptions(optionsModels, settingsModel) {
        let options = {};

        optionsModels.forEach((model) => {
            let value = model.get("VALUE");
            try {
                value = JSON.parse(value);
            } catch (e) {
                value = model.get("VALUE");
            }

            options[ model.get("KEY") ] = value;
        });

        if ( window.localStorage ) {
            let ls_options = window.localStorage.getItem("options");
            if ( ls_options ) {
                ls_options = JSON.parse(ls_options);
                options = deepMixin(options, ls_options);
            }
        }

        // Опции дополняются... настройками из таблицы settings!
        const keys = ["ID_DEFAULT_CURRENCY", "DEFAULT_CURRENCY_CHARCODE"];
        keys.forEach((key) => {
            // В sys_client_options и в settings не должны быть
            // одинаковые ключи
            let keyLower = key.toLocaleLowerCase();
            if (
                key in options && options.hasOneProperty(key)
                    || keyLower in options && options.hasOneProperty(keyLower)
            ) {
                throw Error(`Duplicate key "${key} in options and settings"`);
            }

            options[keyLower] = settingsModel.get(key);
        });

        this.options = new Backbone.Model(options);
        this.trigger("options:ready");
    }

    async initModules(modules, project) {
        this.modules = {};
        this.newModulesConfigs = {};

        for (const newModuleName in project.modules || {}) {
            const moduleConfig = project.modules[ newModuleName ];
            this.newModulesConfigs[ newModuleName ] = moduleConfig;
        }

        // только один!
        let moduleName = modules[0];
        if ( !moduleName ) {
            this.trigger("modules:ready");
            return;
        }

        const [Module] = await asyncRequire([
            "modules/" + moduleName + "/Module"
        ]);

        let module = new Module(this);
        this.modules[moduleName] = module;

        this.trigger("modules:ready");
    }

    async loadAllModules() {
        const allModulesNames = Object.keys(this.newModulesConfigs);
        await this.requireNewModules(allModulesNames);
    }

    async requireNewModules(modulesNames) {
        const needRequire = modulesNames.filter((moduleName) =>
            !(moduleName in this._requiredNewModules)
        );
        if ( !needRequire.length ) {
            return;
        }

        await asyncRequire(needRequire);

        for (const moduleName of needRequire) {
            this._requiredNewModules[ moduleName ] = true;
        }
    }

    addAppToAutoRun(CustomApp) {
        this.appsToRunFromNewModules.push(CustomApp);
    }

    matchModules({module, modules, notModule, notModules}) {
        //todo исключения если указано одновременно notModule module и тд
        if (
            module && (modules || notModule || notModules )
            || modules && (module || notModule || notModules )
            || notModule && (module || modules || notModules )
            || notModules && (module || modules || notModule )
        ) {
            throw new Error("Wrong uses matchModules");
        }

        if ( module ) {
            return this.hasModule(module);
        }
        if ( modules ) {
            return this.hasModule(modules);
        }
        if ( notModule ) {
            return !this.hasModule(notModule);
        }
        if ( notModules ) {
            return !this.hasModule(notModules);
        }
        return true;
    }

    hasModule(moduleName) {
        if ( !this.modules ) {
            // eslint-disable-next-line no-cyrillic-string/no-cyrillic-string
            throw new Error("Слишком рано используешь метод hasModule!");
        }
        if ( Array.isArray(moduleName) ) {
            return this.hasSomeModule(moduleName);
        }
        return moduleName in this.modules;
    }

    hasSomeModule(someModules) {
        if ( !Array.isArray(someModules) ) {
            throw new Error(`Type of checked modules must be an array. Your type is ${typeof someModules}.`);
        }

        const systemModules = Object.keys(this.modules);

        for (let systemModuleName of systemModules) {
            systemModuleName = systemModuleName.toLowerCase();

            for (let someModuleName of someModules) {
                someModuleName = someModuleName.toLowerCase();

                if ( systemModuleName == someModuleName ) {
                    return true;
                }
            }
        }

        return false;
    }

    /**
     * Точка входа
     */
    initRightsManager() {
        this.rights = new RightsManager();
        this.rights.on("ready", this.trigger.bind(this, "rights:ready"));
    }

    // =================

    remoteLog(type, title, description) {
        try {
            // title: только строка
            // description: может быть строкой или объектом
            let log = {
                timestamp: new Date().toISOString(),
                type,
                title,
                devFile: this.devFile,
                brow: aboutBrow(),
                userId: this.user.id,
                url: location.href,
                description,
                login: this.user.model.get("login"),
                roles: this.user.roles
            };

            let reportUrl = location.protocol + "//" + location.host + "/stats/";

            $.ajax({
                type: "POST",
                url: reportUrl,
                data: JSON.stringify(log),
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                success: () => {
                    console.log("remote log write success");
                },
                failure: (errMsg) => {
                    console.log("failed to log error", log, "with error", errMsg);
                }
            });
        } catch (e) {
            // если использовать console.error,
            // то получится рекурсия
            console.log("error: ", e);
        }
    }

    // TODO: run app with file
    async openExternal(fileModel, options = { query: false }) {
        if ( !( fileModel instanceof Backbone.Model ) ) {
            fileModel = new Backbone.Model(fileModel);
        }

        let ext = fileModel.get("FILE_EXT");
        let action = this.getExtAction(ext);

        if ( action == "office" ) {
            const fileURL = fileModel.get("FILE_URL");
            const officeURL = await this.getOfficeURL(fileURL, options);

            this.runApp({
                type: "Iframe",
                title: fileModel.get("FILE_NAME"),
                src: officeURL
            });
        }

        if ( action == "iframe" ) {
            let fileName = fileModel.get("FILE_NAME");
            fileName = fileName.replace(/\//g, "_");
            let url = "/api/download-file/" + fileModel.id + "/as/" + fileName;

            this.runApp({
                type: "Iframe",
                title: fileModel.get("FILE_NAME"),
                ext: fileModel.get("FILE_EXT") ?? "",
                src: url
            });
        }
    }

    async getOfficeURL(fileURL, options = { query: false }) {
        const settingsModel = SETTINGS.collection.first();
        const enabledProxy = settingsModel.get("USE_FILES_PROXY") == 1;

        if ( enabledProxy ) {
            const officeURL = await this.getProxyOfficeURL(fileURL, options);
            return officeURL;
        } else {
            const officeURL = await this.getNativeOfficeURL(fileURL, options);
            return officeURL;
        }
    }

    async getProxyOfficeURL(fileURL, options = { query: false }) {
        const response = await Api.request({
            root: "customlogic",
            entity: "files-proxy",
            method: "getFileURL",
            data: {
                filePath: fileURL
            }
        });

        let proxyDownloadURL = response.result;
        if ( options && options.query ) {
            proxyDownloadURL += "?" + options.query;
        }

        const officeURL = OFFICE_ONLINE_URL + encodeURIComponent(proxyDownloadURL);
        return officeURL;
    }

    async getNativeOfficeURL(fileURL, options = { query: false }) {
        /*
        ლ(ಠ_ಠლ)
        model.FILE_NAME = "test s probelom i #sharp"
        model.FILE_URL = "uploads/1533207289918_test_s_probelom_i_#sharp.xlsx"
        fileUrl = "http://dev-perm.log-os.ru/uploads/1533207289918_test_s_probelom_i_%23sharp.xlsx"
        url = "https://view.officeapps.live.com/op/view.aspx?src=http%3A%2F%2Fdev-perm.log-os.ru%2Fuploads%2F1533207289918_test_s_probelom_i_%2523sharp.xlsx"
        */

        let protocol = location.href.split(":")[0];
        let domen = location.href.replace(/^https?:\/\//i, "").split("/")[0];

        fileURL = fileURL.replace("\\", "/");
        const fileName = fileURL.split("/").slice(-1)[0];
        let encodedName;

        if ( options && options.query ) {
            encodedName = `${fileName}?${options.query}`;
        } else {
            encodedName = encodeURIComponent(fileName);
        }

        let encodedUrl = fileURL
            .split("/")
            .slice(0, -1)
            .concat(encodedName)
            .join("/");
        const fileUrl = protocol + "://" + domen + "/" + encodedUrl;

        const officeURL = OFFICE_ONLINE_URL + encodeURIComponent(fileUrl);
        return officeURL;
    }

    canOpenExternal(fileModel) {

        if ( !( fileModel instanceof Backbone.Model ) ) {
            fileModel = new Backbone.Model(fileModel);
        }

        let ext = fileModel.get("FILE_EXT");
        let action = this.getExtAction(ext);

        return !!action;
    }

    showNotification(params) {
        this.apps.channel("Notification").add(params);
    }

    initAppManager() {
        this.apps = new AppManager({
            appsToRunFromNewModules: this.appsToRunFromNewModules
        });

        this.listenTo(this.apps, "ready", this.trigger.bind(this, "apps:ready"));
    }

    async requireFixesForForm(formName) {
        for (const moduleName in this.newModulesConfigs) {
            const moduleConfig = this.newModulesConfigs[ moduleName ];

            if ( !moduleConfig.forms ) {
                continue;
            }

            const moduleFormParams = moduleConfig.forms[formName];
            if ( !moduleFormParams ) {
                continue;
            }

            if ( moduleFormParams.hasForm ) {
                continue;
            }

            await this.requireNewModules([moduleName]);
        }
    }

    async getFormClass({
        table,
        Form
    }) {

        // require new module if need
        const newModuleName = this.getNewModuleNameByEntityName(table);

        let inputForm = Form;
        let FormClass;

        if ( isFunction(inputForm) ) {
            FormClass = inputForm;
        } else if ( isString(inputForm) ) {
            const formPath = `apps/Form/forms/${inputForm}`;
            const exportsArr = await asyncRequire([formPath]);
            FormClass = exportsArr[0];
        } else if ( newModuleName && !inputForm && table ) {
            await this.requireNewModules([newModuleName]);

            for (const appName in this.runs) {
                const appConfig = this.runs[appName];

                const isJournalForThatEntity = (
                    appConfig.type == "Grid"
                    && appConfig.tableName == table
                    && isFunction(appConfig.Form)
                );

                if ( isJournalForThatEntity ) {
                    FormClass = appConfig.Form;
                }
            }
        } else if ( !newModuleName && !inputForm && table ) {
            const gridConfig = allGridsConfig[table];
            if ( gridConfig ) {
                const formName = gridConfig.form2;
                // RoleForm has another way
                const formPath = gridConfig.formPath || `apps/Form/forms/${formName}`;
                const exportsArr = await asyncRequire([formPath]);
                FormClass = exportsArr[0];
            }
        }

        if ( !FormClass ) {
            throw new Error(`cannot detect form for ${table}`);
        }

        return FormClass;
    }

    async runForm({
        table,
        id,
        Form,
        data,
        isAdd = false,
        removeOnCancel = false
    }) {
        const FormClass = await this.getFormClass({ table, Form });

        if ( table ) {
            const storage = RowsStorage.get(table);
            // refresh cache before show
            await storage.refreshGet(id);
        }

        this.runApp({
            type: "Form2",
            table,
            id,
            Form: FormClass,
            data,
            isAdd,
            removeOnCancel
        });
    }

    getNewModuleNameByEntityName(entityName) {
        for (const moduleName in this.newModulesConfigs) {
            const moduleConfig = this.newModulesConfigs[ moduleName ];

            if ( !moduleConfig.entities ) {
                continue;
            }

            if ( moduleConfig.entities.includes(entityName) ) {
                return moduleName;
            }
        }
    }

    /**
     * Синтаксический сахар для конструкции system.apps.run()
     * Запускает приложение в соответствии с задаными параметрами
     * @param appParams
     * @param callback
     * @returns {*|void}
     */
    runApp(appParams, callback) {
        if ( !this.apps ) {
            return console.log("Error, apps not supported");
        }

        this.apps.run(appParams, callback);
    }

    async run({app, title}) {
        if ( app in this.runs ) {
            return await this.apps.run(app);
        } else {
            let newModuleWithThatApp = null;

            for (const moduleName in this.newModulesConfigs) {
                const moduleConfig = this.newModulesConfigs[ moduleName ];

                if ( !moduleConfig.menuItems ) {
                    continue;
                }

                const hasMenuItem = moduleConfig.menuItems.includes(app);
                if ( !hasMenuItem ) {
                    continue;
                }

                newModuleWithThatApp = moduleName;
                await this.requireNewModules([ moduleName ]);
            }

            if ( !(app in this.runs) ) {
                if ( newModuleWithThatApp ) {
                    throw new Error(`module ${newModuleWithThatApp} does not contain menu item: ${app}`);
                } else {
                    throw new Error(`unknown app ${app}`);
                }
            }

            const appParams = this.getRunConfig(app);
            appParams.title = title;
            return await this.apps.run(appParams);
        }
    }

    hasExternal(ext) {
        return ext.toLowerCase() in this.actionByExt;
    }

    getExtAction(ext) {
        return this.actionByExt[ext.toLowerCase()];
    }

    async makeURL(params, callback) {
        const response = await Api.request({
            root: "customlogic",
            entity: "sys-link",
            method: "createLink",
            data: {
                linkData: params
            }
        });
        const linkId = response.result;

        let url = "#" + btoa(linkId);
        callback(null, url);

        return url;
    }

    async parseURL(url, callback) {
        if ( !callback ) {
            callback = function() {};
        }

        let id = url.split("#")[1] || "";
        id = atob(id);

        let data;
        // обратная совместимость,
        // могут существовать сообщения содержащие ссылки старого формата
        if ( isNaN(+id) ) {
            try {
                data = urlArgs2object(id);
            } catch (err) {
                data = false;
            }
        }

        if ( isObject(data) ) {
            callback(null, data);
            return data;
        }

        const response = await Api.request({
            root: "customlogic",
            entity: "sys-link",
            method: "getLinkData",
            data: {
                linkId: id
            }
        });
        if ( response.result ) {
            data = response.result;
        }
        data = deepMixin({}, data);

        callback(null, data);
        return data;
    }

    runLink(url) {
        this.parseURL(url, (err, data) => {
            if ( err ) {
                console.error(err);
                return;
            }

            if ( data.table && data.row ) {
                this.runForm({
                    table: data.table,
                    id: data.row
                });
            }

            if ( data.table && !data.row ) {
                this.apps.run({
                    type: "GridFromLink",
                    data
                });
            }

            if ( data.tab ) {
                this.apps.run({
                    type: "GridLinkedTab",
                    tab: data.tab
                });
            }
        });
    }

    async setModule(moduleName) {
        try {
            await ajax({
                method: "HEAD",
                noConsoleError: true,
                url: `/js/modules/${moduleName}/Module.js`
            });

            moduleName = `["${moduleName}"]`;
            const {result} = await Api.request({
                root: "customlogic",
                entity: "system",
                method: "set-module",
                data: { moduleName }
            });

            if ( result.status === "success" ) {
                localStorage.setItem("modules", moduleName);
                console.log(result.status);
            } else {
                console.log(result.status, result.message);
            }
        } catch (e) {
            if ( e.status === 404 ) {
                console.log("Wrong module name.");
            }
        }
    }

    existsApp(iteration) {
        return this.apps.runned.some(iteration);
    }

    getRunConfig(menuItemName) {
        return deepClone(this.runs[ menuItemName ]);
    }

    setRunConfig(appName, appParams) {
        this.runs[ appName ] = deepClone(appParams);
    }
}

function asyncRequire(paths) {
    return new Promise((resolve) => {
        window.require(paths, (...exportsArr) => {
            resolve(exportsArr);
        });
    });
}
